import { render, staticRenderFns } from "./TextMessaging.vue?vue&type=template&id=e9078518&scoped=true&"
import script from "./TextMessaging.vue?vue&type=script&lang=js&"
export * from "./TextMessaging.vue?vue&type=script&lang=js&"
import style0 from "./TextMessaging.vue?vue&type=style&index=0&id=e9078518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9078518",
  null
  
)

export default component.exports